import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const PdfFileIcon = createSvgIcon(
  <g>
    <rect x="8" y="8" width="48" height="48" rx="10" fill="#E5252A" />
    <text
      x="32"
      y="38"
      textAnchor="middle"
      fill="#FFFFFF"
      fontFamily="Inter, ui-sans-serif, system-ui, sans-serif"
      fontSize="13"
      fontWeight="800"
    >
      PDF
    </text>
  </g>,
  'PdfFileIcon',
);
